
const CDropdown=({
    label,
    name,
    value,
    options = [],
    optionLabel = "label",
    optionValue = "value",
    onChange,
    error,
    firstOption = "Select",
    className = "",
    required = false,
})=>{
 return (
        <div className={className}>
            {label && (
                <label className="form-label">
                    {label}
                    {required && (
                        <span className="text-danger"> *</span>
                    )}
                </label>
            )}

            <select
                name={name}
                value={value}
                onChange={onChange}
                className="form-select"
            >
                <option value="">
                    {firstOption}
                </option>

                {options.map((item, index) => (
                    <option
                        key={index}
                        value={item[optionValue]}
                    >
                        {item[optionLabel]}
                    </option>
                ))}
            </select>

            {error && (
                <div className="text-danger mt-1">
                    {error}
                </div>
            )}
        </div>
    );
};

export default CDropdown;